export var gridSize = 4;
//# sourceMappingURL=grid.js.map